module.exports = __webpack_public_path__ + "media/images/banner_available-59efc87c7253bea8191975ef4c7f98a5.png";